import {
  Avatar,
  Box,
  Card,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';
import getInitials from '../../utils/getInitials';

const TrainerResults = ({ trainers }) => {
  return (
    <Card>
      <Box minWidth={700}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>ID</TableCell>
              <TableCell>Total Registered User Count</TableCell>
              <TableCell>Signed Up</TableCell>
              <TableCell>Active Subscription</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {trainers.map((trainer) => {
              return (
                <TableRow hover key={trainer._id}>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Avatar
                        sx={{ height: 40, width: 40, mr: 1 }}
                        src={trainer.avatarUrl}
                      >
                        {getInitials(trainer.name)}
                      </Avatar>
                      <div>
                        <Link
                          color="inherit"
                          component={RouterLink}
                          to={`/admin/trainers/${trainer._id}`}
                          variant="h6"
                        >
                          {trainer.name}
                        </Link>
                      </div>
                    </Box>
                  </TableCell>
                  <TableCell>{trainer._id}</TableCell>

                  <TableCell>{trainer.totalUserCount}</TableCell>
                  <TableCell>{trainer.createdAt}</TableCell>
                  <TableCell>
                    {trainer.hasActiveTrainerSubscription ? 'Yes' : 'No'}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Card>
  );
};

export default TrainerResults;
